module.exports = __webpack_public_path__ + "media/eat5.399c8651.mp4";